import ReactDOM from 'react-dom';
import scrollIntoView from 'dom-scroll-into-view';

export default function scrollToElement(ref) {
  window.requestAnimationFrame(() => {
    const domNode = ReactDOM.findDOMNode(ref);
    const rect = domNode.getBoundingClientRect();
    const shouldScroll = rect.top < 0 || rect.bottom > window.innerHeight;
    if (shouldScroll) {
      scrollIntoView(domNode, window, {
        alignWithTop: false,
        offsetBottom: 20,
      });
    }
  });
}
